import * as React from 'react';
import { CardContainerArea } from './style';

interface Props {
  children: React.ReactNode;
}

export const VexterCard: React.FC<Props> = ({ children }) => {
  return <CardContainerArea>{children}</CardContainerArea>;
};
